import { GetMRBSubList } from "./GetMRBSubList.js";
import { enumMRBList } from "../constants";

export function FindFirstMRB(selectedBoxes) {
  var theList = GetMRBSubList(selectedBoxes, enumMRBList.mrbOnly);
  if (theList.length == 0) return null;
  else return theList[0];
}
